import clientService from '@/api/client'
import { CLIENT } from '../types'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    clients: [],
    clientId: ''
  },
  getters: {
    clientId (state) {
      return state.clientId
    }
  },
  mutations: {
    [CLIENT.CLIENT_SET] (state, clients) {
      state.clients = clients
    },
    [CLIENT.SET_CLIENT_ID] (state, id) {
      state.clientId = id
    }
  },
  actions: {
    getClients: function ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        clientService.getClients().then((response) => {
          commit(CLIENT.CLIENT_SET, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    setClientId ({commit}, id) {
      commit(CLIENT.SET_CLIENT_ID, id)
    }
  }
}
